// Bloc HP "Rejoignez les premiers joueurs Hexagon" (sections/home-email-
// interest.liquid) — enregistre les textes du toast flottant partage
// (assets/contact-form-ajax.js, charge AVANT ce fichier — voir l'ordre des
// <script> dans la section) pour ce formulaire precis.
//
// 2026-08-09 : le formulaire soumet nativement (Shopify gere sa propre
// verification anti-spam puis le vrai POST — voir contact-form-ajax.js pour
// le detail). Ce script se contente d'enregistrer les textes de succes
// aupres de HexagonContactForm ; c'est contact-form-ajax.js qui affichera
// le toast APRES le rechargement, en detectant ?contact_posted=true dans
// l'URL de retour. Fonctionne aussi si ce script ne charge pas (juste sans
// toast, le mail part quand meme).
(function () {
  var form = document.getElementById('HomeEmailInterestForm');
  var section = document.getElementById('hp-email-interest');
  if (!form || !section || !window.HexagonContactForm) return;

  window.HexagonContactForm.init(form, {
    successTitle: section.getAttribute('data-toast-success-title'),
    successText: section.getAttribute('data-toast-success-text')
  });
})();
